// components/bulkestimatebox.js
import React, { useState } from "react";
import {
  Box,
  Text,
  Flex,
  NumberInput,
  NumberInputField,
  Button,
} from "@chakra-ui/react";

const BulkEstimateBox = ({ it_name, manufacturer }) => {
  const [value, setValue] = useState("");
  const [desiredPrice, setDesiredPrice] = useState("");

  const handleClick = () => {
    if (!value || isNaN(Number(value)) || Number(value) <= 0) {
      alert("유효한 요청수량을 입력해주세요.");
      return;
    }
    // if (
    //   !desiredPrice ||
    //   isNaN(Number(desiredPrice)) ||
    //   Number(desiredPrice) <= 0
    // ) {
    //   alert("유효한 희망가격을 입력해주세요.");
    //   return;
    // }

    const query = new URLSearchParams({
      it_name,
      manufacturer,
      stock: value,
      requestprice: desiredPrice,
    }).toString();

    window.open(`/estimate/quote_request?${query}`, "_blank");
  };

  return (
    <Box
      mt={8}
      p={4}
      border="1px solid #dcdcdc"
      borderRadius="md"
      background="#ffffff"
    >
      <Text fontWeight="bold" mb={2} fontSize="md" color="black">
        대량 구매를 원하시나요?
      </Text>
      <Box w="100%" mb={2} height="30px">
        <NumberInput
          size="sm"
          min={1}
          mr="0.5%"
          width="49%"
          onChange={(val) => setValue(val)}
          float="left"
        >
          <NumberInputField
            placeholder="요청수량"
            _placeholder={{ color: "gray.300" }}
          />
        </NumberInput>
        <NumberInput
          size="sm"
          min={1}
          width="49%"
          ml="0.5%"
          float="left"
          onChange={(val) => setDesiredPrice(val)}
        >
          <NumberInputField
            placeholder="희망가격"
            _placeholder={{ color: "gray.300" }}
          />
        </NumberInput>
      </Box>
      <Button
        bg="#111"
        color="#fff"
        size="sm"
        height="40px"
        width="100%"
        flexShrink={0}
        onClick={handleClick}
      >
        판다봇 견적요청{" "}
      </Button>
    </Box>
  );
};

export default BulkEstimateBox;
